<script setup>
   import { onMounted, onUnmounted, ref, watchEffect, inject } from 'vue'
   import { modalHide, modalShow } from '@/composables/bootstrap'
   import { useRouter } from 'vue-router'

   const router = useRouter()

   const $storeAuth = inject('$storeAuth')
   const $storeApp = inject('$storeApp')

   const props = defineProps({
      show: Boolean,
   })

   const inMaintenance = ref(false)
   const version = ref(null)
   let intervalID = null

   const checkVisibility = () => {
   if (document.visibilityState === 'hidden') {
      clearInterval(intervalID)
      intervalID = null
   } else if (document.visibilityState === 'visible') {
      $storeAuth.checkAuthentication()
      clearInterval(intervalID)
      intervalID = setInterval(() => $storeAuth.checkAuthentication(), 10000)
   }
   }

   const checkVersion = () => {
   document.addEventListener('visibilitychange', checkVisibility)
   checkVisibility()

   onUnmounted(() => {
      clearInterval(intervalID)
      document.removeEventListener('visibilitychange', checkVisibility)
   })
   }

   const modalID = 'maintenance-mode'

   watchEffect(() => {
   inMaintenance.value = $storeApp.maintenance
   version.value = $storeApp.version

   if (!inMaintenance.value && version.value !== null && version.value !== localStorage.getItem('cg_version')) {
      localStorage.removeItem('cg_version')
      setTimeout(() => router.go(), 300)
   }

   if (inMaintenance.value) {
      setTimeout(() => modalShow(modalID), 100)
      checkVersion()
   } else {
      modalHide(modalID)
      if (intervalID) {
         clearInterval(intervalID)
         intervalID = null
      }
      document.removeEventListener('visibilitychange', checkVisibility)
   }
   })
</script>

<template>
   <Modal :id="modalID" size="large" static>
      <template #body>
         <div class="cg-column-content align-items-center text-center">
            <Loader size="45" />
            <div v-if="false">
               <h3>An update has been released, Please wait...</h3>
               <p>Your session will automatically resume in a few moments.</p>
            </div>
            <div v-else>
               <h3>An update is currently in progress, Please wait...</h3>
               <p>Your session will automatically resume when the update is finished.</p>
            </div>
         </div>
      </template>
   </Modal>
</template>